module.exports = __webpack_public_path__ + "b4bd0b0f095b9a9495672a6666eedd4a.pdf";